import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-small-loader',
  templateUrl: './small-loader.component.html',
  styleUrls: ['./small-loader.component.scss']
})
export class SmallLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {  }

}
